import { render, staticRenderFns } from "./NewProductLineKitData.vue?vue&type=template&id=b8e80072"
import script from "./NewProductLineKitData.vue?vue&type=script&lang=js"
export * from "./NewProductLineKitData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports